import React from 'react'
import ReactDOM from 'react-dom'
import { Modal, Spin, message } from 'antd'
import request from 'meinian-package/src/utils/request'

import './index.less'

const getFileSuffix = (filename) => {
  if (filename) {
    const index = filename.lastIndexOf('.')
    const type = filename.substring(index + 1)
    return type.toUpperCase().substring(0, 3)
  }
}
const getEtxname = (url) => {
  const index = url.lastIndexOf('.')
  return url.substr(index)
}
class DownLoadImg extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: true,
      loading: false
    }
  }

  componentDidMount() {
    const { source } = this.props
    if (source === 2) {
      this.fetchPsdResource()
    }
  }

  onPsdClick() {
    const { psdUrl, source } = this.props
    if (source === 2) {
      location.href = this.state.dataPsdUrl
    } else {
      location.href = `${psdUrl}?response-content-type=application/octet-stream&response-content-disposition=attachment%3Bfilename%3D${encodeURIComponent(this.fileName())}${getEtxname(psdUrl)}`
    }
  }

  fileName() {
    const { gender, type, rootPattern, pattern } = this.props
    return `${gender}_${type}_${rootPattern}${pattern}_${Date.now().toString(16)}`.replace(/,/ig, '_')
  }

  async fetchPsdResource() {
    // await this.setState({ loading: true })
    try {
      const dataPsdUrl = await request.get('/fashion/pattern/get/psd', { params: { sourceImageId: this.props.sourceImageId } })
      this.setState({ dataPsdUrl, loading: false })
    } catch (err) {
      message.error(err)
      // this.setState({ loading: false })
    }
  }

  render() {
    const { psdUrl, mainUrl } = this.props
    const { dataPsdUrl, visible, loading } = this.state
    return (
      <Modal
        visible={visible}
        onCancel={() => this.setState({ visible: false })}
        footer={null}
        closable
        title={null}
        width={480}
      >
        <Spin spinning={loading}>
          <div className="download-img-content">
            <div className="title">请选择下载类型</div>
            <div className="dialog-body">
              <a
                className="item"
                href={`${mainUrl}?response-content-type=application/octet-stream&response-content-disposition=attachment%3Bfilename%3D${encodeURIComponent(this.fileName())}.jpg`}
              >JPG图片</a>
              {
                (psdUrl || dataPsdUrl)
                  ? <a className="item" onClick={this.onPsdClick.bind(this)}>{getFileSuffix(dataPsdUrl) }源文件</a>
                  : null
              }
            </div>
          </div>
        </Spin>
      </Modal>
    )
  }
}
let div = document.createElement('div')
function destory(resolve, reject, val) {
  const unmountResult = ReactDOM.unmountComponentAtNode(div)
  if (unmountResult && div.parentNode) {
    div.parentNode.removeChild(div)
    resolve(val)
  }
}

export default {
  show(patternParams) {
    return new Promise((resolve, reject) => {
      div = document.createElement('div')
      div.id = 'download-img-mask-wrapper'
      document.body.appendChild(div)
      ReactDOM.render(<DownLoadImg {...patternParams} closeClick={destory.bind(this, resolve, reject)} />, div)
    })
  },
}
